module.exports = __webpack_public_path__ + "img/profile-inactive.9e1a9262.svg";